<template>
  <v-card class="text-center mx-auto pa-4 d-none" flat max-width="400">
    <div id="print" ref="print">
      <div
        :style="
          description && IS_IR
            ? 'width: 100%;max-width: 100vh;height: 100%;background-image: url(https://core-qr.terminalads.ir/media/img/print_visit.webp);background-size: contain; background-repeat: no-repeat;background-position: top center'
            : description && !IS_IR
            ? 'width: 100%;max-width: 100vh;height: 100%;background-image: url(https://core-qr.terminalads.com/media/img/print_visit.webp);background-size: contain; background-repeat: no-repeat;background-position: top center'
            : ''
        "
      >
        <img
           v-if="value?.img_url" 
          :src="value.img_url" 
          alt="QR Code" 
          style="width: 50vh; margin: 12px auto 0; display: block"
        />

        <div
          :style="'padding: 0 38px'"
          style="
            text-align: center;
            display: flex;
            flex-direction: column;
            align-items: center;
          "
        >
          <img id="text-img" alt="" style="max-width: 31vh; margin-top: 16px" />
                   </div>

          <img
            id="link-img"
            alt=""
            style="width: 50vh; max-width: 50vh; margin-top: 8px"
          />
      </div>

    </div>
  </v-card>
</template>

<script>
import { ir, IS_IR } from "../../../check_domain_ir";

export default {
  name: "printPage",

  props: {
    value: Object,
   
    description: Boolean,
  },

  data() {
    return {
      url: ir(process.env.VUE_APP_ROOT),
      loading: false,
    };
  },
 watch: {
    value: {
      handler(newVal) {
        if (newVal) {
          this.$nextTick(() => {
            let link = document.getElementById("link-img");
            let text = document.getElementById("text-img");
            
            if (link && text) {
              this.convertToImg(this.getQrUrl, link);
              this.convertToImg(newVal.title, text, true);
            }
          });
        }
      },
      immediate: true,
      deep: true
    }
  },


  computed: {
    
    getQrUrl() {
      if (!!this.value?.identifier)
        return this.value?.domain?.name? this.value?.domain?.name + this.value?.identifier: this.value?.identifier;
      return this.value?.domain?.name||"";
    },
   
  },

  methods: {

    brightness(input) {
      const color = "" + input,
        isHEX = color.indexOf("#") == 0;
      if (isHEX) {
        const m = color
          .substr(1)
          .match(color.length == 7 ? /(\S{2})/g : /(\S{1})/g);
        if (m)
          var r = parseInt(m[0], 16),
            g = parseInt(m[1], 16),
            b = parseInt(m[2], 16);
      }
      if (typeof r != "undefined") return (r * 299 + g * 587 + b * 114) / 1000;
    },
    convertToImg(text, el, callback = false, color = "black") {
      let svgData = "";

      const TextToSVG = require("text-to-svg");
      TextToSVG.load(
        "/fonts/Vazir-Regular.ttf",
        async function (err, textToSVG) {
          const attributes = { fill: color };
          const options = {
            x: 0,
            y: 0,
            fontSize: 32,
            anchor: "top",
            attributes: attributes,
          };
          svgData = textToSVG.getSVG(text, options);

          const svgDataBase64 = btoa(unescape(encodeURIComponent(svgData)));
          el.src = `data:image/svg+xml;charset=utf-8;base64,${svgDataBase64}`;
          if (callback) this.imageLoaded();
        }.bind(this),
      );
    },
    imageLoaded(e) {
      setTimeout(() => {
        this.$nextTick(() => {
          const printableContent = document.getElementById("print");
          const printWindow = window.open(
            "",
            "printwindow",
            "height=1200,width=1000",
          );
          printWindow.document.write(
            '<html><head><title>print preview</title><style>html{-webkit-print-color-adjust: exact;color-adjust: exact;} @page{size: letter;}</style></head><body style="margin: 0;padding: 0;height: 100vh;overflow: hidden;max-height: 100vh;display: flex;flex-direction: column;align-items: center;justify-content: space-between;">',
          );
          printWindow.document.write(printableContent.innerHTML);
          printWindow.document.write("</body></html>");

          setTimeout(() => {
            printWindow.print();
            printWindow.close();
          }, 2000);

          printWindow.addEventListener("unload", () => {
            this.$emit("close");
          });
        });
      }, 50);
    },
  },
};
</script>

<style scoped></style>
